module.exports = __webpack_public_path__ + "img/sl.svg";